import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage, updateEnterpriseLogoRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type useEnterpriseUpdateProfileImageProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useEnterpriseUpdateProfileImage = ({
  setAlertText = () => { },
}: useEnterpriseUpdateProfileImageProps) => {
  const client = useQueryClient();

  const { mutate: updateEnterpriseProfileImage, isLoading: isUpdatingEnterpriseProfileImage } =
    useMutation({
      mutationFn: (variables: { logo?: string; cover_image?: string }) =>
        axiosInstance.post(updateEnterpriseLogoRoute, variables).then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
          client.invalidateQueries([profileKey]);
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
    });

  return {
    updateEnterpriseProfileImage,
    isUpdatingEnterpriseProfileImage,
  };
};
